module.exports = __webpack_public_path__ + "img/vaginal-ring_x2.6dc16587.png";